function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import produce from 'immer';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonSize } from 'common/components/button/constants';
import { SelectReact } from 'common/components/select';
// eslint-disable-next-line import/no-cycle
import { BucketPaneReact } from 'common/widgets/bucket-pane';
import { DefaultCustomBucket } from 'common/query-builder/query-entry-section/constants';
import { Bucket } from 'common/widgets/bucket-pane/types';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { useTranslation } from 'common/i18n/hooks';
import { RowProps } from '../types/catalog';
export type CustomizeBucketsProps = RowProps & {
  isOpen: boolean;
  toggleOpen: () => void;
};
export const CustomizeBuckets = (props: CustomizeBucketsProps) => {
  var _props$entry2;
  const {
    t
  } = useTranslation();
  const getBucketLabel = (): string | null => {
    var _props$entry;
    const bucket = (_props$entry = props.entry) === null || _props$entry === void 0 ? void 0 : _props$entry.behavior.customBucket;
    if (bucket) {
      return "Custom bucket size **".concat(bucket.bucketSize, " between ").concat(bucket.min, "-").concat(bucket.max, "**");
    }
    return null;
  };
  const bucketLabel = getBucketLabel();
  const onMenuChange = () => {
    props.toggleOpen();
  };
  const updateCustomBucket = (newCustomBucket: Bucket | null) => {
    const updatedEntry = produce(props.entry, draft => {
      draft.behavior.customBucket = newCustomBucket;
    });
    props.updateEntry(updatedEntry);
    props.toggleOpen();
    const currentCustomBucket = props.entry.behavior.customBucket;
    if (newCustomBucket) {
      props.dispatchTrack(QueryEntrySectionTrackingEvent.ApplyCustomBucket, _objectSpread(_objectSpread({}, props.getEntryTrackingProps()), {}, {
        'Bucket min': newCustomBucket.min,
        'Bucket max': newCustomBucket.max,
        'Bucket size': newCustomBucket.bucketSize,
        'Is editing': !!currentCustomBucket
      }));
    }
  };
  const bucket = (_props$entry2 = props.entry) === null || _props$entry2 === void 0 ? void 0 : _props$entry2.behavior.customBucket;
  return bucketLabel || props.isOpen ? <SelectReact className='subitem-select' label={bucketLabel || "Customize Buckets"} open={props.isOpen} theme={SelectTheme.Tertiary} alwaysShowCaret size={ButtonSize.Small} preventClose onMenuChange={onMenuChange} data-sentry-element="SelectReact" data-sentry-component="CustomizeBuckets" data-sentry-source-file="customize-buckets.tsx">
      <div slot='body'>
        {props.isOpen &&
      // @todo(metrics) Rewrite BucketPane to split up the segment vs
      // event use cases instead of jamming them both together in one component
      // with two very different use cases.
      <BucketPaneReact eventNames={props.sectionProps.eventNames || []} header={t("query-builder.actions.customize-range")} maxNumBuckets={1000} onChangeSelectedBucket={updatedBucket => updateCustomBucket(updatedBucket.detail)} onResetBucket={() => updateCustomBucket(null)} resetBucket={Boolean(bucket)} selectedBucket={bucket || DefaultCustomBucket} selectedUnit='units' units={undefined} unitsAsProperty={false} />}
        {/* TODO: Use BasicBucketPane directly once BucketPane is rewritten.
          We'll keep using the old one to make sure everything still works. */}
        {/* {props.isOpen && (
            <BasicBucketPane
              eventNames={props.sectionProps.eventNames || []}
              header={t(`query-builder.actions.customize-range`)}
              maxNumBuckets={1000}
              onChangeSelectedBucket={(updatedBucket) => updateCustomBucket(updatedBucket)}
              onResetBucket={() => updateCustomBucket(null)}
              resetBucket={Boolean(bucket)}
              selectedBucket={bucket || DefaultCustomBucket}
              selectedUnit='units'
              units={undefined}
              unitsAsProperty={false}
            />
          )} */}
      </div>
    </SelectReact> : null;
};